import {ActionLink} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';

const DocumentTypeSelector = observer(({onTypeSelected}) => {
  return (
    <div className='col-10 mx-auto'>
      <div className='h3 jumbo pt3 pb2 max-width-2 center'>
        <FormattedMessage id='employees.hiring.documents.Do you want to upload an annotatable PDF or do a regular file upload?'/>
      </div>
      <div className='flex flex-col md-flex-row row-gap-2 mxn3 pt3 pb4'>
        <div className='col col-12 md-col-6 px3'>
          <ActionLink onClick={() => onTypeSelected('pdf_template')} className='full-height block p3 bg-white bg-hover-smoke border rounded center'>
            <div className='mb2'>
              <i className='material-icons h1 dodger'>{'tune'}</i>
            </div>
            <span className='waterloo'>
              <FormattedMessage id='employees.hiring.documents.Upload and annotate a PDF'/>
            </span>
          </ActionLink>
        </div>
        <div className='col col-12 md-col-6 px3'>
          <ActionLink onClick={() => onTypeSelected('static_document')} className='full-height block p3 bg-white bg-hover-smoke border rounded center'>
            <div className='mb2'>
              <i className='material-icons h1 dodger'>{'attach_file'}</i>
            </div>
            <span className='waterloo'>
              <FormattedMessage id='employees.hiring.documents.Regular file upload (cannot be annotated)'/>
            </span>
          </ActionLink>
        </div>
      </div>
    </div>
  );
});

export default DocumentTypeSelector;
